import { PhoneIcon } from "@heroicons/react/24/outline";
import React from "react";
import { parsePhone } from "util/phone";
import { ContactValueLabel, ContactValueRow } from "./display-row";
import {
    DevicePhoneActions,
    PhoneTriggerLink,
    UnparseablePhoneRow,
    phoneNumberParses,
} from "./phone-primitives";

interface GuestPhoneDisplayProps {
    value: string;
    label: string | null;
}

export const GuestPhoneDisplay: React.FC<GuestPhoneDisplayProps> = props => {
    const { value, label } = props;

    if (!value) {
        return null;
    }

    if (!phoneNumberParses(value)) {
        return <UnparseablePhoneRow value={value} label={label} />;
    }

    const parsed = parsePhone(value);

    return (
        <ContactValueRow Icon={PhoneIcon}>
            <DevicePhoneActions
                value={value}
                intent="call"
                renderTrigger={binding => (
                    <PhoneTriggerLink binding={binding} display={parsed.display} />
                )}
            />
            <ContactValueLabel label={label} />
        </ContactValueRow>
    );
};
